/* eslint-disable */

export const validateCpf = (cpf: string) => {
  let v1 = 0;
  let v2 = 0;
  let aux = false;

  for (let i = 1; cpf.length > i; i++) {
    if (cpf[i - 1] !== cpf[i]) {
      aux = true;
    }
  }

  if (aux === false) {
    return false;
  }

  for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
    v1 += +cpf[i] * p;
  }

  v1 = (v1 * 10) % 11;

  if (v1 === 10) {
    v1 = 0;
  }

  if (v1 !== +cpf[9]) {
    return false;
  }

  for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
    v2 += +cpf[i] * p;
  }

  v2 = (v2 * 10) % 11;

  if (v2 === 10) {
    v2 = 0;
  }

  if (v2 !== +cpf[10]) {
    return false;
  }

  return true;
};

export const validateCnpj = (cnpj: string) => {
  const value = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (value.length !== 14) {
    return false;
  }

  if (!/^[A-Z0-9]{12}\d{2}$/.test(value)) {
    return false;
  }

  if (/^(\d)\1{13}$/.test(value)) {
    return false;
  }

  const getValue = (char: string) => char.charCodeAt(0) - 48;

  const calcDigit = (base: string, weights: number[]) => {
    const sum = base
      .split('')
      .reduce((acc, char, index) => acc + getValue(char) * weights[index], 0);

    const mod = sum % 11;

    return mod < 2 ? 0 : 11 - mod;
  };

  const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const firstDigit = calcDigit(value.slice(0, 12), firstWeights);

  if (firstDigit !== Number(value[12])) {
    return false;
  }

  const secondDigit = calcDigit(value.slice(0, 13), secondWeights);

  return secondDigit === Number(value[13]);
};

export const validateCpfCnpj = (value: string) => {
  const clean = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (/^\d{11}$/.test(clean)) {
    return validateCpf(clean);
  }

  if (/^[A-Z0-9]{12}\d{2}$/.test(clean)) {
    return validateCnpj(clean);
  }

  return false;
};

export function maskPhone(value: string, locale?: Object) {
  value = value.replace(/\D/g, '');

  if (value.length > 10) {
    value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
  } else {
    value = value.replace(/^(\d{3})(\d)/g, '($1) $2');
  }

  value = value.replace(/(\d)(\d{4})$/, '$1-$2');

  return value;
}

export function uploadFileValidate(
  str: string,
  validation: { type: string; length?: number },
) {
  const { type, length } = validation;
  if ((length || length === 0) && str.length !== length) {
    return false;
  }
  if (type === 'number') {
    return /^\d+$/.test(str);
  }
  return /^[a-z]+$/i.test(str);
}
